import { render, staticRenderFns } from "./KundeMedia.vue?vue&type=template&id=53e60b25&"
import script from "./KundeMedia.vue?vue&type=script&lang=js&"
export * from "./KundeMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports